import { AxiosInstance } from 'axios';

/**
 * @param {AxiosInstance} api
 * @param {{filter?: *, sort?: *}} [params]
 */
export async function msgSentStatistics(api, params) {
  return await api.get(`im/admin/msgSentStatistics`, { params });
}
